import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Conversation } from "./models/Message";


export default class MessagesVuexModule extends AbacoVuexModule {

    @State({ default: false}) canCreateConversation!: boolean;
    @State({ default: false}) canLockConversation!: boolean;
    @State() curConversation!: Conversation | null;

}
